export default __webpack_public_path__ + "static/media/Metropolis-Thin.90c61711.otf";